import { Component, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { throttle } from 'lodash';

import { environment } from '../../../environments/environment';

import { AuthService } from '../../services/auth.service';
import { DocsService } from '../../services/docs.service';
import { LoaderService } from '../../services/loader.service';
import { NavigationService } from '../../services/navigation.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'kd-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    loader = false;
    needInit = true;
    ready = false;
    throttledOnScroll: () => void = throttle(this.onScroll, environment.throttleInterface);

    constructor(
        private authService: AuthService,
        private docsService: DocsService,
        private loaderService: LoaderService,
        private navigationService: NavigationService,
        private renderer: Renderer2,
        private title: Title,
        private userService: UserService,
    ) { }

    ngOnInit() {
        this.title.setTitle(environment.title);

        const touch = Boolean('ontouchstart' in window || navigator.maxTouchPoints);
        if (touch) {
            this.renderer.addClass(document.body, environment.bodyTouchClass);
        }

        this.loaderService.getStateChange().subscribe((state: boolean) => {
            setTimeout(() => {
                this.loader = state;
            });
        });

        this.navigationService.onNavigation().subscribe(() => {
            if (this.needInit) {
                this.needInit = false;
                this.initApp();
            }
        });
    }

    initApp(): void {
        this.loaderService.start();

        Promise.all([
            this.authService.init(),
            this.docsService.init(),
            this.userService.init()
        ]).then(() => {
            this.setReady();
        }).catch(() => {
            this.setReady();
        });
    }

    private onScroll(): void {
        this.docsService.emitScroll();
    }

    private setReady(): void {
        this.ready = true;
        this.loaderService.stop();
    }
}
